import React from 'react';
import { Tooltip, TooltipContent, TooltipPortal, TooltipProvider, TooltipTrigger } from 'src/shared/components/ui/tooltip';

/** Shared styling for the compact icon controls used in admin table rows. */
export const iconActionClassName = 'inline-flex items-center justify-center p-2 rounded-md hover:bg-grey-10';

type RowIconActionProps = {
    label: string;
    children: React.ReactNode;
};

/**
 * Wraps a row's icon control in a tooltip naming what it does. The tooltip sits to the
 * left so it does not cover the column header above it.
 */
const RowIconAction = ({ label, children }: RowIconActionProps) => (
    <TooltipProvider delayDuration={200}>
        <Tooltip>
            <TooltipTrigger asChild>{children}</TooltipTrigger>
            <TooltipPortal>
                <TooltipContent side='left'>{label}</TooltipContent>
            </TooltipPortal>
        </Tooltip>
    </TooltipProvider>
);

export default RowIconAction;
